{
  "columnResizer": "Ridimensionamento colonne",
  "drag": "Trascina",
  "loading": "Caricamento...",
  "loadingMore": "Caricamento altri...",
  "resizeColumn": "Ridimensiona colonna",
  "sortAscending": "Ordinamento crescente",
  "sortDescending": "Ordinamento decrescente"
}
